import styled from "styled-components";
import { Table } from "antd";

export const StyledTable = styled(Table)`
  .old-visit-row {
    background-color: #fff5f5 !important;

    td {
      color: rgba(0, 0, 0, 0.45) !important;
      background-color: #fff5f5 !important;
    }

    &:hover > td {
      background-color: #ffe3e3 !important;
    }
  }
`;
